import { Printer } from "lucide-react";

export const PrintButton = () => (
  <button
    type="button"
    onClick={() => window.print()}
    data-testid="print-page-button"
    className="print:hidden inline-flex items-center gap-2 rounded-xl border border-gray-200 font-semibold bg-white px-4 py-2 text-sm text-ink-2 transition-colors hover:border-brand hover:text-brand"
  >
    <Printer className="h-4 w-4" strokeWidth={1.75} />
    Print / Save as PDF
  </button>
);
